/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown>, template: NonNullable<unknown> }} Ccsl_Export_File_NameInputs */

const en_ccsl_export_file_name = /** @type {(inputs: Ccsl_Export_File_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - CCSL - ${i?.template}.docx`)
};

const fr_ccsl_export_file_name = /** @type {(inputs: Ccsl_Export_File_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - CCSL - ${i?.template}.docx`)
};

const de_ccsl_export_file_name = /** @type {(inputs: Ccsl_Export_File_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} – CCSL – ${i?.template}.docx`)
};

const it_ccsl_export_file_name = /** @type {(inputs: Ccsl_Export_File_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - CCSL - ${i?.template}.docx`)
};

const ru_ccsl_export_file_name = /** @type {(inputs: Ccsl_Export_File_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} – CCSL – ${i?.template}.docx`)
};

const es_ccsl_export_file_name = /** @type {(inputs: Ccsl_Export_File_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - CCSL - ${i?.template}.docx`)
};

const zh_cn2_ccsl_export_file_name = /** @type {(inputs: Ccsl_Export_File_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - CCSL - ${i?.template}.docx`)
};

const ja_ccsl_export_file_name = /** @type {(inputs: Ccsl_Export_File_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - CCSL - ${i?.template}.docx`)
};

const hi_ccsl_export_file_name = /** @type {(inputs: Ccsl_Export_File_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - सीसीएसएल - ${i?.template}.docx`)
};

const pt_pt2_ccsl_export_file_name = /** @type {(inputs: Ccsl_Export_File_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - CCSL - ${i?.template}.docx`)
};

/**
* | output |
* | --- |
* | "{title} - CCSL - {template}.docx" |
*
* @param {Ccsl_Export_File_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_file_name = /** @type {((inputs: Ccsl_Export_File_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_File_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_file_name(inputs)
	if (locale === "de") return de_ccsl_export_file_name(inputs)
	if (locale === "it") return it_ccsl_export_file_name(inputs)
	if (locale === "ru") return ru_ccsl_export_file_name(inputs)
	if (locale === "es") return es_ccsl_export_file_name(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_file_name(inputs)
	if (locale === "ja") return ja_ccsl_export_file_name(inputs)
	if (locale === "hi") return hi_ccsl_export_file_name(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_file_name(inputs)
	return en_ccsl_export_file_name(inputs)
});